import { useTranslation } from "react-i18next";
import { useState, useEffect, useContext, useRef } from "react";
import { GlobalContext } from "../context/GlobalContext";
import { ConfirmModal, Button, HeaderNavigation } from "mobily-ui-library";
import { JSEncrypt } from 'jsencrypt';

import Loader from "../components/Loader/Loader";
import CartPage from "../components/CartPage/CartPage";
import EmptyCartPage from "../components/EmptyCartPage/EmptyCartPage";
import StickyPriceBar from "../components/StickyPriceBar/StickyPriceBar";
import DeviceLogin from "../components/DeviceLogin/DeviceLogin";
import ErrorModal from "../components/ErrorModal/ErrorModal";
import DeviceOTP from "../components/DeviceOTP/DeviceOTP";
import DeviceTerms from "../components/DeviceTerms/DeviceTerms";
import TermsOTP from "../components/TermsOTP/TermsOTP";
import TwoYearCoverageLogin from "../components/TwoYearCoverageLogin/TwoYearCoverageLogin";

import getCookies from "../Util/getCookies";
import { deleteCookie } from "../Util/deleteCookies";
import { updateAndValidateSc, cancelShoppingcart, cemInitiateOTP, getProjectionCheckoutBySCId, getFindInBranch } from "../api/api.ts";

import { handleApiError } from '../functions/handleApiError';

import './Pages.scss';
import MapModal from "../components/MapModal/MapModal";
import FindInBranch from '../components/FindInBranch/FindInBranch';

const win: any = window;
// const serverURL = win['base_portal_url'];
// const errorPage = win['errorPageURL'];

const branchRadius = win['branch_radius'];

function Pages() {
    const { t } = useTranslation();
    const { state, dispatch }: any = useContext(GlobalContext);
    const { rtl, outOfStock, currentPage, scData, productData } = state;

    const childRef: any = useRef("");

    const [emptyFlag, setEmptyFlag] = useState(false);
    const [shoppingCartId, setShoppingCartId] = useState<any>("");
    const [productId, setProductId] = useState("");
    const [againGraphQl, setAgainGraphQl] = useState<any>(false);
    const [tamaraFee, setTamaraFee] = useState('');
    const [errorCode, setErrorCode] = useState('');
    const [isCemInitiateOTPGenericError, setIsCemInitiateOTPGenericError] = useState(false);
    const [isCemInitiateOTPError, setIsCemInitiateOTPError] = useState(false);
    const [timer, setTimer] = useState(0);
    const [isLoginOTPError, setisLoginOTPError] = useState(false);
    const [isLoginStatusCode, setIsLoginStatusCode] = useState(false);
    const [showDiscardAppleCare, setShowDiscardAppleCare] = useState<any>(false);

    const [isFindInBranch, setIsFindInBranch] = useState(false);
    const [mapModal, setMapModal] = useState(false);
    const [address, setAddress] = useState('');
    const [latLng, setLatLng] = useState<any>('');
    const [cityName, setCityName] = useState('');
    const [placeId, setPlaceId] = useState('');
    const [branchNotFound, setBranchNotFound] = useState(false);
    const [isGenericError, setIsGenericError] = useState(false);
    const [soldOut, setSoldOut] = useState(false)
    const [preBackOrderDisabled, setPreBackOrderDisabled] = useState(false);

    // const [transId, setTransId] = useState('');
    // const [errCode, setErrCode] = useState('');

    useEffect(() => {
        const cookieScId: any = window.location.href.includes("localhost") ?
            "044ae17c-1c36-46ff-982f-dfdaff03e738" : getCookies('device-scId');
        const cookieXCoId: any = window.location.href.includes("localhost") ?
            "PORC260724063625574_80864" : getCookies('device-xCoId');
        setShoppingCartId(cookieScId);
        !!!win["xCoId"] && (win["xCoId"] = cookieXCoId);
        !!!win['shoppingCartId'] && (win['shoppingCartId'] = cookieScId);
        dispatch({ type: 'XCOID', payload: { xCoId: cookieXCoId } });
    }, [dispatch]);

    const [currentTime, setCurrentTime] = useState(Date.now());

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentTime(Date.now());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (shoppingCartId?.length > 0) {
            dispatch({ type: 'LOADER', payload: { loading: true } })
            updateAndValidateSc(shoppingCartId)
                .then((res: any) => {
                    if (res.status === 200 && res.data) {
                        if (res.data?.shoppingCart?.cartTotalPrice) {
                            setEmptyFlag(true)
                            dispatch({ type: "SC_RESPONSE", payload: { scData: res.data?.shoppingCart } })
                            setProductId(res.data?.shoppingCart?.offerContainer[0].cartItem[0].productOffering.id);
                            const appleCare = res.data?.shoppingCart?.offerContainer[0].cartItem?.filter((item: any) => {
                                if (item?.product?.name.includes("AppleCare+ warranty one time")) {
                                    return item;
                                } else if (item?.product?.name.includes("AppleCare+ warranty recurring")) {
                                    return item;
                                }
                            })?.[0];
                            const acName = appleCare?.product?.name;
                            const acId = appleCare?.productOffering?.id;
                            const acPrice = appleCare?.itemTotalPrice?.[0]?.price?.taxIncludedAlteredAmount?.value;
                            const acObj = { acId: acId, acName: acName, price: acPrice };

                            const priceAlterationArray = res.data?.shoppingCart?.offerContainer[0]?.cartItem[0]?.itemPrice[0]?.priceAlteration
                            const priceAlterationType = priceAlterationArray ? priceAlterationArray[0]?.priceAlterationType : "";
                            const referenceId = priceAlterationArray ? priceAlterationArray[0]?.referenceId : "";
                            const isSubsidy = priceAlterationType === "promotion" && !referenceId.includes("flatdiscount") && !referenceId.includes("percentdiscount");
                            const getAdditionalAttribute = (name: string) =>
                                res.data?.shoppingCart?.offerContainer?.[0]?.additionalAttributes?.find(
                                    (attr: any) => attr?.name === name
                                )?.value;
                            const isForwardTradeIn = getAdditionalAttribute("InstallmentFTI") === 'true' ? true : false;
                            const forwardTradeInObj = {
                                TotalFTIAmountWithVat: getAdditionalAttribute("TotalPriceVAT") ?? "",
                                TotalFTIAmount: getAdditionalAttribute("TotalPrice") ?? "",
                                TotalFTIInstalment: getAdditionalAttribute("TotalPriceExcludingDownpayment") ?? "",
                                FTIInstalmentMonthlyWithVat: getAdditionalAttribute("MonthlyCommitmentAmt") ?? "",
                                FTICommitmentPeriod: getAdditionalAttribute("PromotionCommitmentPeriod") ?? ""
                            }

                            const isInstallment = getAdditionalAttribute("InstallmentFTI") !== 'true' && priceAlterationType === "manualPriceOverride" ? true : false;

                            dispatch({ type: 'APPLECARE_APPLIED', payload: { appleCareApplied: acName ? true : false } });
                            dispatch({ type: "SELECTED_AC_PLAN", payload: { selectedAcPlan: acObj } });
                            dispatch({ type: 'IS_SUBSIDY_APPLIED', payload: { isSubsidyApplied: isSubsidy } });
                            dispatch({ type: 'IS_INSTALLMENT_APPLIED', payload: { isInstallmentApplied: isInstallment } });
                            dispatch({ type: 'IS_FTI_APPLIED', payload: { isFTIApplied: isForwardTradeIn } });
                            dispatch({ type: 'FORWARD_TRADE_IN_PLAN', payload: { forwardTradeInData: forwardTradeInObj } });


                            //tamara fee only with update cart item[1] 
                            const tamaraItem = res.data?.shoppingCart?.offerContainer[0]?.cartItem.filter((item: any) => (item.product.name.toLowerCase() === 'tamara fee'));
                            if (tamaraItem.length > 0) {
                                const tamaraFee = tamaraItem[0].itemPrice[0].price.dutyFreeAlteredAmount.value;
                                setTamaraFee(tamaraFee.toString());
                            }

                            if (isSubsidy || isInstallment || isForwardTradeIn) {
                                getProjectionCheckoutBySCIdApi(res.data?.shoppingCart?.id, res.data?.shoppingCart?.validityToken);
                            } else {
                                dispatch({ type: 'LOADER', payload: { loading: false } })
                            }
                        } else {
                            dispatch({ type: 'LOADER', payload: { loading: false } })
                        }
                    } else if (res.status === 200 && res.data?.status?.sourceCode === "1111") {
                        deleteCookie('device-count');
                        deleteCookie('device-scId');
                        deleteCookie('device-xCoId');
                        deleteCookie('device-poid');
                        deleteCookie('device-journeyName');
                        win.updateCartItemCount(0);
                        dispatch({ type: 'LOADER', payload: { loading: true } })
                        cancelShoppingcartApi(shoppingCartId);
                    } else {
                        deleteCookie('device-count');
                        deleteCookie('device-scId');
                        deleteCookie('device-xCoId');
                        deleteCookie('device-poid');
                        deleteCookie('device-journeyName');
                        win.updateCartItemCount(0);
                        setEmptyFlag(false);
                        dispatch({ type: 'LOADER', payload: { loading: false } });
                    }
                }).catch(() => {
                    deleteCookie('device-count');
                    deleteCookie('device-scId');
                    deleteCookie('device-xCoId');
                    deleteCookie('device-poid');
                    deleteCookie('device-journeyName');
                    if (win?.updateCartItemCount) {
                        win?.updateCartItemCount(0);
                    }
                    setEmptyFlag(false);
                    dispatch({ type: 'LOADER', payload: { loading: false } });
                })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, shoppingCartId, t])

    const handleCheckout = () => {
        win?.MixpanelTracker?.trackEvent("Cart Checkout Started");
        setAgainGraphQl(true);
    };

    const handleContinue = () => {
        setMapModal(true);
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        dispatch({ type: "LOADER", payload: { loading: true } })
    }

    const handleMapModalClose = () => {
        setMapModal(false);
    }
    const callFindInBranchApi = async (latLng: any, cityName: string, placeId: string) => {
        console.log("callFindInBranchApi", latLng, cityName, placeId);
        const responseData = productData.getProductOfferByID[0];
        const deviceSKU = responseData?.specCharValueUse.filter(
            (val: any) => val.name === "SKU"
        )[0]?.specCharacteristicValue[0]?.value;
        let branchData = {
            deviceSKU,
            "location": latLng,
            "radius": branchRadius ?? "5", "cityName": cityName,
        }
        await getFindInBranch(branchData)
            .then((response: any) => {
                if (response.status == 200) {
                    dispatch({ type: "SET_BRANCH_DETAILS", payload: { branchData: response?.data } })
                    dispatch({ type: "CURRENT_PAGE", payload: { currentPage: "findInBranch" } });
                    dispatch({ type: "LOADER", payload: { loading: false } });
                } else if (response.status == 201) {
                    dispatch({ type: "LOADER", payload: { loading: false } });
                    setBranchNotFound(true);
                }
            })
            .catch((error: any) => {
                dispatch({ type: "LOADER", payload: { loading: false } });
                setErrorCode(error?.response?.status);
                setIsGenericError(true);
            })
    }
    console.log("Address", address, latLng, cityName, placeId);
    const handleAddress = (value: any, latLng: any, cityName: any, placeId: any) => {
        console.log("Address from pages", value, latLng, cityName, placeId);
        setAddress(value);
        setLatLng(latLng);
        setCityName(cityName);
        setPlaceId(placeId);
        dispatch({ type: "LOADER", payload: { loading: true } });
        callFindInBranchApi(latLng, cityName, placeId);
    }

    const handleLoginSubmit = (number: string, userID: string) => {
        const lang = rtl ? 'ar' : 'en';
        cemCallInitiateOTPApi(number, userID, lang)
        dispatch({ type: "LOADER", payload: { loading: true } });
    }

    const handleLoginCLose = () => {
        setShowDiscardAppleCare(true)
    }

    const handleModalGotIt = () => {
        setIsCemInitiateOTPError(false);
        setIsCemInitiateOTPGenericError(false);
    }

    const cancelShoppingcartApi = (shoppingCartId: any) => {
        cancelShoppingcart(shoppingCartId)
            .then((response: any) => {
                if (response?.status === 200) {
                    window.location.href = win["productUrl"];
                }
            }).catch(err => {
                const config = Object.assign(err?.config, { serviceName: 'cancelShoppingCart' });
                const error = { ...err, config }
                handleApiError(error);
            })
    }

    const handleTryAgain = () => {
        setisLoginOTPError(false);
    }

    const cemCallInitiateOTPApi = (msisdn: any, userID: any, lang: any) => {
        // const publicKey = win['public_key'];
        const cemPublicKey = win['cem_public_key'];
        const jsencrypt = new JSEncrypt();
        jsencrypt.setPublicKey(cemPublicKey);

        const msisdnVal = msisdn.length > 0 ? msisdn.replace(/^0/, '966') : '';
        const mobileNumber = jsencrypt.encrypt(msisdnVal);
        const idNumber = jsencrypt.encrypt(userID);

        cemInitiateOTP(mobileNumber, idNumber, lang)
            .then((res: any) => {
                setErrorCode(res?.data?.status?.sourceCode ? res?.data?.status?.sourceCode : res?.status);
                if (res?.status === 200 && res?.data) {
                    if (res?.data?.status?.sourceCode === 'MAPI-000') {
                        setTimer(120);
                        dispatch({ type: "LOADER", payload: { loading: false } });
                        dispatch({ type: 'INITATE_OTP_DATA', payload: { OTPData: res?.data } });
                        dispatch({ type: 'DEVICE_MOBILENUMBER', payload: { msisdn: msisdn.replace(/^966/, '0') } });
                        dispatch({ type: 'CURRENT_PAGE', payload: { currentPage: 'deviceOTP' } });
                    } else {
                        dispatch({ type: "LOADER", payload: { loading: false } });
                        // const errCode = res?.status
                        // setTransId(res?.config?.headers['X-Transaction-Id']);
                        // setErrCode(errCode);
                        setIsCemInitiateOTPGenericError(true);
                    }
                } else {
                    dispatch({ type: "LOADER", payload: { loading: false } });
                    // const errCode = res?.status
                    // setTransId(res?.config?.headers['X-Transaction-Id']);
                    // setErrCode(errCode);
                    setIsCemInitiateOTPGenericError(true);
                }
            }).catch(err => {
                if (err?.response) {
                    dispatch({ type: "LOADER", payload: { loading: false } });

                    if (err?.response?.status === 401 && err?.response?.data?.status?.sourceCode === 'MAPI-401-5') {
                        // const errCode = err?.response?.status;
                        // setTransId(err?.response?.config?.headers['X-Transaction-Id']);
                        // setErrCode(errCode);
                        setIsCemInitiateOTPError(true);
                    } else
                        if (err?.response.status === 401 && err?.response?.data?.status?.sourceCode === 'MAPI-401-09') {
                            setisLoginOTPError(true);
                            setIsLoginStatusCode(true);
                        }
                        else
                            if (err?.response.status === 401 && err?.response?.data?.status?.sourceCode === 'MAPI-401-10') {
                                setisLoginOTPError(true);
                                setIsLoginStatusCode(false);
                            }
                            else {
                                // const errCode = err?.response?.status
                                // setTransId(err?.response?.config?.headers['X-Transaction-Id']);
                                // setErrCode(errCode);
                                setIsCemInitiateOTPGenericError(true);
                            }
                } else {
                    dispatch({ type: "LOADER", payload: { loading: false } });
                    setIsCemInitiateOTPGenericError(true);
                }
            })
    }

    const getProjectionCheckoutBySCIdApi = (id: any, token: any) => {
        getProjectionCheckoutBySCId(id, token).then((response: any) => {
            if (response?.status === 200) {
                const otpVerificationData = response?.data?.sections.filter((section: any) => {
                    return (section.sectionId === 'DevicesOTPVerification')
                });
                const pNumber = otpVerificationData[0]?.steps[0]?.options[0]?.fields[0]?.value;
                const CustomerInfo = otpVerificationData[0]?.steps[0]?.fields[2]?.value;
                const newStack = otpVerificationData[0]?.steps[0]?.fields[8]?.value;
                dispatch({ type: "DEVICE_MOBILENUMBER", payload: { msisdn: pNumber } });
                dispatch({ type: "CUSTOMER_INFO", payload: { customerInfo: JSON.parse(CustomerInfo) } });
                dispatch({ type: "NEW_STACK", payload: { newStack: newStack } });
                dispatch({ type: 'LOADER', payload: { loading: false } });
            } else {
                handleApiError(response);
            }
        }).catch(err => {
            handleApiError(err);
        })
    }

    const handleOrderViaDelivery = () => {
        setBranchNotFound(false)
        setIsFindInBranch(false);
        dispatch({ type: "LOADER", payload: { loading: false } });
        dispatch({ type: 'CURRENT_PAGE', payload: { currentPage: 'cartPage' } });
    }

    const handleBranchNotFound = () => {
        setBranchNotFound(false)
        setIsFindInBranch(true)
        setSoldOut(true)
        dispatch({ type: "LOADER", payload: { loading: false } });
        dispatch({ type: 'CURRENT_PAGE', payload: { currentPage: 'cartPage' } });
    }

    const handleGenericError = () => {
        dispatch({ type: "LOADER", payload: { loading: false } });
        setIsGenericError(false);
        dispatch({ type: 'CURRENT_PAGE', payload: { currentPage: 'cartPage' } });
    }
    const handleBack = () => {
        dispatch({ type: "CURRENT_PAGE", payload: { currentPage: "cartPage" } });
        window.history.back();
    }

    const poid = getCookies('device-poid');
    const xCoId = getCookies('device-xCoId');
    const journeyName = getCookies('device-journeyName');

    return (
        <>
            <div id="ecommerceJourneyName" style={{ display: "none" }}>{journeyName}</div>
            <div id="xCorrelationId" style={{ display: "none" }}>{xCoId}</div>
            <div id="sectionId" style={{ display: "none" }}>Cart</div>
            <div id="DeviceName" style={{ display: "none" }}>{poid}</div>
            <div id="monthly_pay" style={{ display: "none" }}>{poid}</div>
            <div id="upfront" style={{ display: "none" }}>{poid}</div>

            <Loader />
            {currentPage === "cartPage" && (<>
                <main className={rtl ? "container CartPage__Container CartPage__Right" : "container CartPage__Container"}>
                    <div className="CartPage__Header">
                        <div className="CartPage__Header_toggle">
                            <HeaderNavigation
                                rtl={rtl}
                                title={t("Your_Cart")}
                                helpButton={""}
                                onClick={handleBack}
                            />
                            {emptyFlag && (
                                <div className="toggle_Bar">
                                    <Button
                                        rtl={rtl}
                                        className={`SPB__Button ${!isFindInBranch ? "active" : ""}`}
                                        onClick={() => {
                                            if (!outOfStock) {
                                                setIsFindInBranch(false);
                                            }
                                            if (preBackOrderDisabled) {
                                                setPreBackOrderDisabled(false);
                                            }
                                            setSoldOut(false);
                                        }}
                                        variant={outOfStock ? "disabled" : "default"}
                                    >
                                        {t("Device_delivery")}
                                    </Button>

                                    <Button
                                        rtl={rtl}
                                        className={`SPB__Button ${isFindInBranch ? "active" : ""}`}
                                        onClick={() => setIsFindInBranch(true)}
                                    >
                                        {t("Find_in_branch")}
                                    </Button>
                                </div>
                            )}
                        </div>
                    </div>

                    {emptyFlag ? (
                        <CartPage
                            rtl={rtl}
                            productId={productId}
                            setShoppingCartId={setShoppingCartId}
                            againGraphQl={againGraphQl}
                            tamaraFee={tamaraFee}
                            setEmptyFlag={setEmptyFlag}
                            currentTime={currentTime}
                            isfindInBranch={isFindInBranch}
                            setIsFindInBranch={setIsFindInBranch}
                            setPreBackOrderDisabled={setPreBackOrderDisabled}
                            soldOut={soldOut}
                            preBackOrderDisabled={preBackOrderDisabled}
                        />
                    ) : (
                        <EmptyCartPage />
                    )}
                </main>

                {emptyFlag && (
                    <StickyPriceBar
                        rtl={rtl}
                        orderPriceData={scData}
                        handleCheckout={handleCheckout}
                        handleContinue={handleContinue}
                        checkOutOfStock={soldOut}
                        isFindInBranch={isFindInBranch}
                        checkoutDisabled={preBackOrderDisabled}
                    />
                )}
            </>)}

            <>
                {currentPage === 'login' &&
                    (<DeviceLogin
                        ref={childRef}
                        handleSubmit={handleLoginSubmit}
                        handleHeaderCancel={handleLoginCLose} />
                    )}

                {currentPage === 'deviceOTP' && (
                    <DeviceOTP
                        timer={timer}
                        setTimer={setTimer}
                        handleHeaderCancel={handleLoginCLose}
                    />
                )}

                {currentPage === 'TermsOTP' && (
                    <TermsOTP
                        handleHeaderCancel={handleLoginCLose}
                    />
                )}

                {currentPage === 'DeviceTerms' && (
                    <DeviceTerms
                        handleHeaderCancel={handleLoginCLose}
                    />
                )}

                {currentPage === "TwoYearCoverageLogin" && (
                    <TwoYearCoverageLogin
                        ref={childRef}
                        handleHeaderCancel={handleLoginCLose}
                    />
                )}
            </>

            {currentPage === 'findInBranch' && (
                <FindInBranch callFindInBranchApi={callFindInBranchApi} setBranchNotFound={setBranchNotFound}
                />
            )}

            {(isCemInitiateOTPError || isCemInitiateOTPGenericError) && (
                <ErrorModal
                    id='duplicate-shopping-cartId'
                    rtl={rtl}
                    description={''}
                    title={isCemInitiateOTPError ? t('contact_not_match') : t('Try_again', { source_code: t(errorCode) })}
                    firstButtonText={t('got_it')}
                    secButtonText={''}
                    modalFirstButtonClick={handleModalGotIt}
                />
            )}

            {isLoginOTPError && (
                <ErrorModal
                    id={'not-a-mobily-number'}
                    rtl={rtl}
                    title={isLoginStatusCode ? t('login_x2') : t('login_x1')}
                    description={''}
                    firstButtonText={t('got_it')}
                    modalFirstButtonClick={handleTryAgain}
                />
            )}

            <ConfirmModal
                id="discardAppleCareModal"
                idBtn="discardAppleCareModalContinue"
                idCloseIcon="discardAppleCareModalClose"
                showModal={showDiscardAppleCare}
                title={t("Discard_AppleCare_coverage")}
                subTitle={t("if_you_go_back")}
                subText={""}
                buttonName={t("CONTINUE_WITH_COVERAGE")}
                outlineButtonName={t("DISCARD_COVERAGE")}
                onclickButton={() => { setShowDiscardAppleCare(false) }}
                onclickOutLineButton={() => { setShowDiscardAppleCare(false); dispatch({ type: 'CURRENT_PAGE', payload: { currentPage: 'cartPage' } }) }}
                showOutlineButton={true}
                showIcon={false}
            ></ConfirmModal>


            {mapModal && (
                <>
                    <div className="DCMapModal__Backdrop" />
                    <MapModal
                        rtl={rtl}
                        handleAddress={handleAddress}
                        handleMapModalClose={handleMapModalClose}
                    />
                </>
            )}

            {branchNotFound && (
                <ErrorModal
                    id={'Branch_not_Found'}
                    rtl={rtl}
                    title={t('Device_Unavailable_In_Branches')}
                    description={t('This_device_isnot_available_in_branches')}
                    firstButtonText={t('order_via_delivery')}
                    modalFirstButtonClick={handleOrderViaDelivery}
                    secButtonText={t('got_it')}
                    modalSecondButtonClick={handleBranchNotFound}

                />
            )}

            {isGenericError && (
                <ErrorModal
                    id={'otp_page_generic_error'}
                    rtl={rtl}
                    title={""}
                    description={t('Try_again', { source_code: t(errorCode) })}
                    firstButtonText={t('got_it')}
                    modalFirstButtonClick={handleGenericError}
                />
            )}

        </>
    )
}

export default Pages